import { Box } from '@mui/material'
import { TimeField } from '@mui/x-date-pickers/TimeField'
import { Dayjs } from 'dayjs'
import { useState } from 'react'
import SelectItemWithSearchPopup from 'components/popups/SelectItemWithSearchPopup'
import { isAMPM } from 'utils/date'
import dayjs from 'dayjs'
import {
  buildTimeRow,
  buildTimeOptions
} from 'components/eventComponents/EventDatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dateToTimeString from 'components/calendar/components'
import Logger from 'services/Logger'
import { getDefaultTimezone } from 'index'

interface AbsoluteReminderTimePickerProps {
  absoluteDT: Dayjs | null
  setAbsoluteDT: React.Dispatch<React.SetStateAction<Dayjs | null>>
  noStyles?: boolean
  tz?: string
}

export default function AbsoluteReminderTimePicker({
  absoluteDT,
  setAbsoluteDT,
  noStyles,
  tz
}: AbsoluteReminderTimePickerProps) {
  const [showTimeMinutesPopup, setShowTimeMinutesPopup] = useState(false)
  Logger.blue('AbsoluteReminderTimePicker:Render', {
    absoluteDT,
    noStyles,
    tz
  })
  return (
    <SelectItemWithSearchPopup
      data={buildTimeOptions(dayjs().startOf('day'), undefined, true, true)}
      scrollToKey={dateToTimeString(
        (absoluteDT ?? dayjs()).add(30, 'minute').startOf('hour').toDate(),
        true
      )}
      width="fit-content"
      placement="bottom"
      open={showTimeMinutesPopup}
      selectedItemId={undefined}
      rowBuilder={(item) => {
        return buildTimeRow({
          item,
          setShowTimeMinutesPopup,
          onAcceptDate: (newTime) => {
            if (!newTime) return
            setAbsoluteDT((prev) => {
              const base = (prev ?? dayjs()).clone()
              return base
                .hour(newTime.hour())
                .minute(newTime.minute())
                .second(0)
            })
          }
        })
      }}
    >
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <TimeField
          value={absoluteDT}
          timezone={getDefaultTimezone()}
          onChange={(newTime) => {
            if (!newTime) return
            setAbsoluteDT((prev) => {
              const base = (prev ?? dayjs()).clone()
              return base
                .hour(newTime.hour())
                .minute(newTime.minute())
                .second(0)
            })
          }}
          ampm={isAMPM()}
          variant="standard"
          size="small"
          onFocus={() => setShowTimeMinutesPopup(true)}
          slotProps={{
            textField: {
              sx: {
                display: 'inline-flex',
                width: 'auto',
                minWidth: 'auto',
                backgroundColor: noStyles ? 'transparent' : '#ffffff',
                borderRadius: '8px',
                maxWidth: isAMPM() ? '78px' : '50px',
                fontSize: '14px',
                padding: '4px 8px',
                '& .MuiInput-root': {
                  fontSize: '14px',
                  width: 'auto',
                  minWidth: 'auto',
                  flexBasis: 'auto',
                  '&:before': {
                    borderBottom: 'none !important'
                  },
                  '&:hover:before': {
                    borderBottom: 'none !important'
                  },
                  '&:after': {
                    borderBottom: 'none !important'
                  }
                },
                '& .MuiInput-input': {
                  padding: 0,
                  cursor: 'pointer',
                  minWidth: 'auto',
                  width: 'auto'
                }
              }
            }
          }}
        />
      </LocalizationProvider>
    </SelectItemWithSearchPopup>
  )
}
